module.exports = "<dl class=\"form-element\">\n    <dt>\n        <label>Adres</label>\n    </dt>\n    <dd>\n        <input\n            ng-class=\"IssueFormLocationsCtrl.isFullWidth ? 'full-width' : ''\"\n            name=\"locations\"\n            ng-model=\"IssueFormLocationsCtrl.locations\"\n        />\n    </dd>\n</dl>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/issues/issue_forms/fragments/locations/issue_form_locations.html
// module id = 676
// module chunks = 0